import React, { useState } from "react";
import "../../App.css";

export default function Politicas() {
  const [language, setLanguage] = useState("en");
  const [brandName] = useState("EconoJournal");
  const legalEmail = "administracion@econojournal.com.ar";

  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "es" : "en"));

  const MailLink = () => (
    <a href={`mailto:${legalEmail}`} className="text-blue-600 underline">
      {legalEmail}
    </a>
  );

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
        <button
          type="button"
          onClick={toggleLanguage}
          style={{
            padding: "10px 16px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            background: "#111827",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {language === "en" ? "Español" : "English"}
        </button>
      </div>

      {language === "en" ? (
        <EnglishContent brandName={brandName} MailLink={MailLink} />
      ) : (
        <SpanishContent brandName={brandName} MailLink={MailLink} />
      )}
    </div>
  );
}

function EnglishContent({ brandName, MailLink }) {
  return (
    <div>
      <h3>Introduction</h3>
      <p>
        {brandName} and its subsidiaries and affiliates take the protection of your Personal Data
        seriously (generally referring to information and data that can identify you as an
        individual, as defined and further explained in Section III). {brandName} is a company
        incorporated in Av de Mayo 1260, 12th floor, Apt. 20, CABA, Argentina.
      </p>
      <p>
        This Global Privacy Notice (&quot;Notice&quot;) applies to all Personal Data we process about you
        (collectively, &quot;you&quot;), including: (a) information collected through our websites and any
        other related sites, applications, or platforms (including mobile access) where this Notice
        is linked (collectively, the &quot;Sites&quot;); and (b) information you provide when you request
        information related to {brandName} or its products and services, and information provided or
        made available to us through your actions (such as downloading or using {brandName}{" "}
        applications, interacting with us via phone, email, or social media, registering for or
        attending a {brandName} or third-party event, requesting information about our services or
        products, or downloading technical documents or other content from {brandName}) (collectively
        with the Sites, the &quot;Services&quot;). This Notice explains how we collect, use, retain, and
        share (&quot;Process&quot; or &quot;Processing&quot;) your Personal Data and what rights you have regarding
        your Personal Data.
      </p>

      <h3>Who are we?</h3>
      <p>
        When this Notice refers to &quot;{brandName}&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;, it includes {brandName} and
        its group of related subsidiaries and affiliates.
      </p>

      <h3>What information do we collect?</h3>
      <p>
        For the purposes of this Notice, “Personal Data” means information that, either alone or in
        combination with other identifying information, can identify you as an individual.
      </p>
      <p>
        Most of the Personal Data we process is provided directly by you when you register, access,
        or use the Services. This information may include:
      </p>
      <ul>
        <li>
          Contact Information: full name, email address, physical postal address and country, phone
          number, and username;
        </li>
        <li>
          Professional Information: company name, department, job title, job description and related
          information such as job function or organizational structure; company details such as size
          or number of employees;
        </li>
        <li>
          Professional or commercial subscriptions: publications you are subscribed to and trainings
          attended;
        </li>
        <li>
          Account Registration Information: unique password that may be associated with a specific
          activation code for the license(s) you have acquired or are entitled to use;
        </li>
        <li>
          Business Transaction Information: types of Services you are interested in and have
          purchased; your purchasing requirements;
        </li>
        <li>Financial Information: billing and payment information;</li>
        <li>
          Survey Responses: information you provide in response to a survey (including on a Site,
          through an app, social media, email, phone, or otherwise), testimonials, or other
          feedback related to the Services, which may be linked to your account, name, title, and/or
          company name; or comments or posts you publish on any Site or linked to your {brandName}{" "}
          User Account;
        </li>
        <li>
          License Compliance and Verification Information: for certain Services, we may collect and
          link device information with your {brandName} User Account or registered email address to
          manage active licenses associated with you or your account; license verification may
          require us to compare this device identification and account data with active licenses
          using an internet connection on your device, during activation and as part of a regular
          license terms update function;
        </li>
        <li>
          Analytics Data: anonymous analytics data, such as feature usage, account segmentation,
          license usage, and error information, to improve the product; For some Services,{" "}
          {brandName} may collect Personal Data related to your Product usage, but you must
          explicitly opt in for such data collection to receive additional offerings, such as
          insights about licensed product usage and support troubleshooting;
        </li>
        <li>
          Location Information: signals from a device (when enabled); location data received or
          derived from social media, sensor data, or IP addresses; and city ZIP code,
          state/province, or country from which a request is received.
        </li>
      </ul>

      <p>
        We may receive your Personal Data indirectly by providing additional information through
        certain notices or banners. If this information is received from a third party, such as a
        social media platform, that third party is responsible for informing you. Such Personal Data
        may include:
      </p>

      <ul>
        <li>
          Cookies, pixels, and beacons: information from cookies, web beacons, pixels, or internet
          data, including your IP address, browser type, operating system, domain name, access
          times, pages visited within a Site, referring website addresses, how you use a Site
          (including the types of products and events you’re interested in, how you navigate through
          a Site, and the items you download);
        </li>
        <li>
          Usage Information: data related to your access and use of our cloud-hosted Services,
          including access logs, usage time, metadata, and other information required to calculate
          fees incurred through the use of such Services;
        </li>
        <li>
          Preferences: information about your industry, preferred type of communication, and the
          types of Services that may interest you based on your activity on the Sites or use of the
          Services;
        </li>
        <li>
          IP Address, device identifiers, internet activity, and Services log data, which may also
          be linked to your username, account, or registered email address, to support our license
          compliance processes and support efforts;
        </li>
        <li>
          Social Media: we may receive personal data about you when you connect through another site
          (e.g., Facebook, WeChat, Twitter, LinkedIn, etc.), and you may check your settings and
          review their data-sharing policies; these sites are responsible for notifying you of any
          sharing of your personal data;
        </li>
        <li>
          Chat and call logs: support records, transcripts, recordings, and replays of calls,
          videos, or chats for fraud detection, quality control, product improvement, sales, and
          training;
        </li>
        <li>Licenses: data regarding any unauthorized or unlawful access or use of the Services;</li>
        <li>Marketing: communications and patterns of those communications;</li>
        <li>
          Event Participation: information provided when registering for a sponsored, co-sponsored,
          or hosted event, webinar, or when accessing premium content (such as whitepapers,
          infographics, case studies, application briefs, data sheets, etc.), including full name,
          job title or function, company name, department, email address, physical postal address
          and country, phone number, and event registration details; {brandName} may also take
          photos, videos, recordings, and/or related content during an event by providing proper
          notice and obtaining consent when required;
        </li>
        <li>
          Purchase Information: details provided when you purchase or register for Services through
          an authorized reseller, including your contact information, professional data, and
          products purchased;
        </li>
        <li>
          Publicly Available Information: publicly available information on professional networking
          sites, trade groups, or social media, which may include your full name, job title or
          function, company name, industry, email address, physical postal address and country, and
          phone number.
        </li>
      </ul>

      <p>
        Personal Data may be de-identified for certain business purposes where identification is not
        required; we maintain such data in a de-identified format and do not attempt to re-identify
        it.
      </p>

      <h3>Legal Bases and Purposes of Using Your Information</h3>
      <p>
        Our primary purpose in processing your Personal Data is to provide our services. This also
        includes processing your Personal Data to: Deliver the contracted services (license
        management, deliveries, and technical support), and Optimize the use and quality of our
        services. In such cases, the legal bases for {brandName}’s use of your Personal Data will be
        that the processing is necessary for fulfilling our contractual obligations and to comply
        with obligations arising from the agreement between you and {brandName}, including managing
        any requests you make to us (“Contract Performance”). We may also process certain Personal
        Data to pursue our legitimate interests in conducting our business, including the growth and
        improvement of our services and enhancing your experience with our services or ensuring
        lawful use, provided that these interests are not overridden by your rights and interests.
        In rare cases, or where required by applicable laws, processing is based on your prior and
        explicit consent. There may also be cases where you voluntarily provide your Personal Data to{" "}
        {brandName} while interacting with us and after acknowledging this Notice, in which case
        your consent is implied. In specific cases, we may also have a legal obligation to process
        your Personal Data.
      </p>

      <p>
        When the processing of your Personal Data is based on your Consent, you have the right to
        withdraw such Consent at any time, without affecting the legitimacy of processing carried
        out before your withdrawal. As permitted by applicable law, we may also process your
        Personal Data for secondary legitimate purposes such as statistical analysis, research, or
        archiving, while applying industry-approved safeguards.
      </p>

      <p>More specifically, the purposes of using Personal Data can be attributed to the following legal bases:</p>

      <p>
        <b>Contract Performance (or measures at your request):</b>
      </p>
      <ul>
        <li>To fulfill or ensure proper performance of any contractual agreement between you and {brandName} (e.g., license agreements).</li>
        <li>To fulfill or satisfy the reason for which you provided the Personal Data (including in the context of your employment relationship).</li>
        <li>To provide information, Services, or related support and post-sale services, and to maintain and improve them.</li>
        <li>To identify you and communicate with you.</li>
        <li>To plan, execute, and manage our relationship with you and perform any related administrative tasks.</li>
      </ul>

      <p>
        <b>Legitimate Interests (unless prohibited by law):</b>
      </p>
      <ul>
        <li>To identify you in order to enforce license agreement terms and combat software piracy.</li>
        <li>To create, maintain, personalize, support, and secure your account(s) with us.</li>
        <li>To send communications related to the Services, including by email, SMS, and social media platforms.</li>
        <li>To detect fraud and pursue information security goals.</li>
        <li>To monitor our sales and Services.</li>
        <li>To help ensure the safety, protection, integrity, and currency of our Services, databases, tech assets, and business.</li>
        <li>To improve, tailor, and personalize our Services.</li>
        <li>To preserve accuracy and verify information with third parties as needed (e.g., for export compliance).</li>
        <li>To enforce this Notice, and our policies, terms of use, license agreements, and other Service-related provisions.</li>
        <li>To conduct research, including market studies and statistical research on site traffic, sales, and other business data to improve our Services.</li>
        <li>To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as an ongoing business or as part of bankruptcy, liquidation, or similar proceedings.</li>
      </ul>

      <p>
        <b>Consent:</b>
      </p>
      <ul>
        <li>To provide personalized, targeted, or location-based content, communications, services, and advertising from us, our affiliates, or partners.</li>
        <li>To be contacted by us, our Affiliates, or Partners to market and promote our Services or those of our Affiliates or Partners.</li>
        <li>To take photographs, videos, recordings, and/or related content of you during an event in which you participate.</li>
      </ul>

      <p>
        <b>Legal Obligation:</b>
      </p>
      <ul>
        <li>To identify you for compliance purposes, including usage, export, and licensing.</li>
        <li>To detect, investigate, and prevent potentially illegal, unlawful, or harmful activities, as permitted or required by applicable law.</li>
        <li>To identify and verify that both the Services and your usage of the Services are properly licensed.</li>
      </ul>

      <h3>Data Subject Rights</h3>
      <p>
        Depending on applicable law, you may have one or more of the following rights as a data
        subject (or consumer under Argentina’s privacy law):
      </p>
      <ul>
        <li>Request correction of inaccurate Personal Data.</li>
        <li>Request additional information about our data collection, use, and disclosure practices.</li>
        <li>Access certain Personal Data.</li>
        <li>Request deletion of specific Personal Data.</li>
        <li>Object to certain processing (e.g., direct marketing).</li>
        <li>Request restrictions on certain processing.</li>
      </ul>

      <p>
        You may use the Services to access or update your information. To submit a privacy request,
        contact: <MailLink />
      </p>
      <p>If not using the above form, please provide sufficient detail for us to understand and address your request.</p>

      <h3>Children</h3>
      <p>
        We do not knowingly process data of children, and the Services are not directed to children
        as defined by local jurisdictional age limits. If you learn that a minor provided Personal
        Data to us without appropriate parental or guardian consent, please contact <MailLink />
      </p>

      <h3>How to Contact Us</h3>
      <p>If you have questions about this Notice, please contact:</p>
      <p>Legal Department</p>
      <p>
        <b> ECONOJOURNAL SRL.</b>
      </p>
      <p>Attn: Global Privacy Officer</p>
      <p>
        Email: <MailLink />
      </p>
      <p>Any Personal Data you share with {brandName} is processed in accordance with this Notice.</p>

      <h3>Special Provisions</h3>
      <p>
        The following provisions apply to: (a) residents of the specifically named geographies; or
        (b) specific situations, as described below, in which these provisions supersede any
        conflicting general statements made previously.
      </p>

      <p>
        <b>License Compliance Provisions</b>
      </p>
      <p>
        As described in your service or license agreement, {brandName} may process certain Personal
        Data to ensure compliance with those agreements and verify that both the service and your
        usage are properly licensed. This includes geographic location data, usernames, email
        addresses, IP addresses, hostnames, MAC addresses, and originating domains. Processing is
        limited to determining if service code files have been modified or if unauthorized use has
        occurred, and enforcing our license compliance program. This may include transferring such
        Personal Data to {brandName} affiliates, service providers, and technology vendors. Where
        specific data types require special treatment under local law, {brandName} takes appropriate
        steps to comply.
      </p>
      <p>
        For clarity, Personal Data collected for license compliance purposes will not be used for
        other purposes such as marketing.
      </p>

      <p>
        <b>Web License Service Provisions</b>
      </p>
      <p>
        As part of the Web License Services, {brandName} processes the following limited Personal
        Data: (a) user’s email address and username, (b) hostname (including IP and MAC address) of
        the machine accessing the service, and (c) usage data (such as accessibility and active
        process info) related to the {brandName} software accessed. This information is processed
        to: (i) provide the service, (ii) improve product performance, resource allocation, and
        support, and (iii) analyze, support, and/or optimize your use of {brandName} Services.
      </p>
    </div>
  );
}

function SpanishContent({ brandName, MailLink }) {
  return (
    <div>
      <h3>Introducción</h3>
      <p>
        {brandName} y sus subsidiarias y afiliadas toman muy en serio la protección de sus Datos
        Personales (en general, información y datos que pueden identificarlo como individuo, según
        se define y explica más adelante en la Sección III). {brandName} es una compañía constituida
        en Av de mayo 1260 piso 12 Depto 20 CABA, Argentina.
      </p>
      <p>
        Este Aviso Global de Privacidad (&quot;Aviso&quot;) se aplica a todos los Datos Personales que
        procesamos sobre usted (en conjunto, &quot;usted&quot;), incluyendo: (a) la información recopilada a
        través de nuestros sitios web y cualquier otro sitio, aplicación o plataforma relacionada
        (incluido el acceso móvil) donde este Aviso esté vinculado (en conjunto, los &quot;Sitios&quot;); y
        (b) la información que usted proporciona cuando solicita información relacionada con{" "}
        {brandName} o sus productos y servicios, y la información que nos proporciona o pone a
        disposición a través de sus acciones (como descargar o usar aplicaciones de {brandName},
        interactuar con nosotros por teléfono, correo electrónico o redes sociales, registrarse o
        asistir a un evento de {brandName} o de terceros, solicitar información sobre nuestros
        servicios o productos, o descargar documentos técnicos u otro contenido de {brandName}) (en
        conjunto con los Sitios, los &quot;Servicios&quot;). Este Aviso explica cómo recopilamos, usamos,
        conservamos y compartimos (&quot;Procesar&quot; o &quot;Procesamiento&quot;) sus Datos Personales y qué
        derechos tiene con respecto a ellos.
      </p>

      <h3>¿Quiénes somos?</h3>
      <p>
        Cuando este Aviso se refiere a &quot;{brandName}&quot;, &quot;nosotros&quot;, &quot;nos&quot; o &quot;nuestro&quot;, incluye a{" "}
        {brandName} y su grupo de subsidiarias y afiliadas relacionadas.
      </p>

      <h3>¿Qué información recopilamos?</h3>
      <p>
        A los efectos de este Aviso, “Datos Personales” significa información que, por sí sola o en
        combinación con otra información identificatoria, puede identificarlo como individuo.
      </p>
      <p>
        La mayor parte de los Datos Personales que procesamos es proporcionada directamente por usted
        cuando se registra, accede o utiliza los Servicios. Esta información puede incluir:
      </p>

      <ul>
        <li>
          Información de contacto: nombre completo, dirección de correo electrónico, dirección
          postal física y país, número de teléfono y nombre de usuario.
        </li>
        <li>
          Información profesional: nombre de la empresa, departamento, cargo, descripción del puesto
          e información relacionada, como función laboral o estructura organizacional; detalles de la
          empresa, como tamaño o cantidad de empleados.
        </li>
        <li>
          Suscripciones profesionales o comerciales: publicaciones a las que está suscripto y
          capacitaciones a las que asistió.
        </li>
        <li>
          Información de registro de cuenta: contraseña única que puede estar asociada a un código
          de activación específico para la(s) licencia(s) que haya adquirido o tenga derecho a usar.
        </li>
        <li>
          Información de transacciones comerciales: tipos de Servicios que le interesan o ha
          comprado; sus requisitos de compra.
        </li>
        <li>Información financiera: datos de facturación y pago.</li>
        <li>
          Respuestas a encuestas: información que proporciona al responder una encuesta (incluyendo
          en un Sitio, a través de una app, redes sociales, email, teléfono u otros medios),
          testimonios u otros comentarios relacionados con los Servicios, que pueden vincularse a su
          cuenta, nombre, cargo y/o nombre de empresa; o comentarios o publicaciones que publique en
          cualquier Sitio o vinculados a su cuenta de usuario de {brandName}.
        </li>
        <li>
          Información de cumplimiento y verificación de licencias: para ciertos Servicios, podemos
          recopilar y vincular información del dispositivo con su cuenta de usuario de {brandName} o
          su dirección de correo registrada para gestionar licencias activas asociadas con usted o
          su cuenta.
        </li>
        <li>
          Datos analíticos: datos analíticos anónimos, como uso de funciones, segmentación de
          cuentas, uso de licencias e información de errores, para mejorar el producto. Para algunos
          Servicios, {brandName} puede recopilar Datos Personales relacionados con su uso del
          producto, pero usted debe aceptarlo expresamente.
        </li>
        <li>
          Información de ubicación: señales desde un dispositivo (cuando está habilitado), datos de
          ubicación recibidos o derivados de redes sociales, sensores o direcciones IP; y código
          postal, estado/provincia o país desde donde se recibe una solicitud.
        </li>
      </ul>

      <h3>Bases legales y finalidades del uso de su información</h3>
      <p>
        Nuestro propósito principal al procesar sus Datos Personales es prestar nuestros servicios.
        Esto también incluye procesar sus Datos Personales para: brindar los servicios contratados
        (gestión de licencias, entregas y soporte técnico) y optimizar el uso y la calidad de
        nuestros servicios. En esos casos, la base legal para el uso de sus Datos Personales por
        parte de {brandName} será que el procesamiento es necesario para cumplir con nuestras
        obligaciones contractuales y con las obligaciones derivadas del acuerdo entre usted y{" "}
        {brandName}.
      </p>

      <p>
        Cuando el procesamiento de sus Datos Personales se base en su consentimiento, usted tiene
        derecho a retirarlo en cualquier momento, sin afectar la legitimidad del procesamiento
        realizado antes de dicho retiro.
      </p>

      <p>
        <b>Ejecución del contrato (o medidas a su pedido):</b>
      </p>
      <ul>
        <li>Cumplir o garantizar el debido cumplimiento de cualquier acuerdo contractual entre usted y {brandName}.</li>
        <li>Cumplir o satisfacer la razón por la cual usted proporcionó los Datos Personales.</li>
        <li>Proporcionar información, Servicios, soporte relacionado y servicios postventa, y mantenerlos y mejorarlos.</li>
        <li>Identificarlo y comunicarnos con usted.</li>
        <li>Planificar, ejecutar y gestionar nuestra relación con usted y realizar tareas administrativas relacionadas.</li>
      </ul>

      <p>
        <b>Intereses legítimos (salvo prohibición legal):</b>
      </p>
      <ul>
        <li>Identificarlo para hacer cumplir los términos del acuerdo de licencia y combatir la piratería de software.</li>
        <li>Crear, mantener, personalizar, respaldar y proteger su(s) cuenta(s) con nosotros.</li>
        <li>Enviar comunicaciones relacionadas con los Servicios, incluido por email, SMS y plataformas de redes sociales.</li>
        <li>Detectar fraude y perseguir objetivos de seguridad de la información.</li>
        <li>Monitorear nuestras ventas y Servicios.</li>
        <li>Ayudar a garantizar la seguridad, protección, integridad y vigencia de nuestros Servicios, bases de datos, activos tecnológicos y negocio.</li>
        <li>Mejorar, adaptar y personalizar nuestros Servicios.</li>
      </ul>

      <p>
        <b>Consentimiento:</b>
      </p>
      <ul>
        <li>Brindar contenido, comunicaciones, servicios y publicidad personalizada, segmentada o basada en ubicación.</li>
        <li>Ser contactado por nosotros, nuestras afiliadas o socios para promocionar nuestros Servicios.</li>
        <li>Tomar fotografías, videos, grabaciones y/o contenido relacionado suyo durante un evento en el que participe.</li>
      </ul>

      <p>
        <b>Obligación legal:</b>
      </p>
      <ul>
        <li>Identificarlo con fines de cumplimiento, incluidos uso, exportación y licencias.</li>
        <li>Detectar, investigar y prevenir actividades potencialmente ilegales, ilícitas o perjudiciales.</li>
        <li>Identificar y verificar que tanto los Servicios como su uso de los Servicios estén debidamente licenciados.</li>
      </ul>

      <h3>Derechos del titular de los datos</h3>
      <p>
        Dependiendo de la legislación aplicable, usted puede tener uno o más de los siguientes
        derechos como titular de los datos:
      </p>
      <ul>
        <li>Solicitar la corrección de Datos Personales inexactos.</li>
        <li>Solicitar información adicional sobre nuestras prácticas de recopilación, uso y divulgación de datos.</li>
        <li>Acceder a determinados Datos Personales.</li>
        <li>Solicitar la eliminación de Datos Personales específicos.</li>
        <li>Oponerse a ciertos procesamientos (por ejemplo, marketing directo).</li>
        <li>Solicitar restricciones sobre ciertos procesamientos.</li>
      </ul>

      <p>
        Puede utilizar los Servicios para acceder o actualizar su información. Para presentar una
        solicitud de privacidad, contáctese a: <MailLink />
      </p>

      <h3>Niños</h3>
      <p>
        No procesamos deliberadamente datos de niños, y los Servicios no están dirigidos a niños
        según los límites de edad definidos por cada jurisdicción. Si sabe que un menor nos
        proporcionó Datos Personales sin el consentimiento apropiado de sus padres o tutores, por
        favor contacte a <MailLink />
      </p>

      <h3>Cómo contactarnos</h3>
      <p>Si tiene preguntas sobre este Aviso, por favor contacte a:</p>
      <p>Departamento Legal</p>
      <p>
        <b>ECONOJOURNAL SRL.</b>
      </p>
      <p>Atn.: Global Privacy Officer</p>
      <p>
        Email: <MailLink />
      </p>
      <p>
        Cualquier Dato Personal que comparta con {brandName} es procesado de acuerdo con este Aviso.
      </p>

      <h3>Disposiciones especiales</h3>
      <p>
        Las siguientes disposiciones se aplican a: (a) residentes de las geografías específicamente
        nombradas; o (b) situaciones específicas, según se describe a continuación, en las que estas
        disposiciones reemplazan cualquier declaración general en conflicto realizada anteriormente.
      </p>

      <p>
        <b>Disposiciones de cumplimiento de licencias</b>
      </p>
      <p>
        Según se describe en su acuerdo de servicio o licencia, {brandName} puede procesar ciertos
        Datos Personales para garantizar el cumplimiento de dichos acuerdos y verificar que tanto el
        servicio como su uso estén debidamente licenciados.
      </p>

      <p>
        <b>Disposiciones del servicio de licencias web</b>
      </p>
      <p>
        Como parte de los Servicios de Licencia Web, {brandName} procesa los siguientes Datos
        Personales limitados: (a) dirección de correo electrónico y nombre de usuario del usuario,
        (b) hostname (incluyendo IP y dirección MAC) de la máquina que accede al servicio y (c)
        datos de uso relacionados con el software de {brandName} al que se accede.
      </p>
    </div>
  );
}